import { RSA } from './rsa'
import JSEncrypt from 'jsencrypt'

const publicKey = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApk2WGYuq26+g3djMgg2VkjyKiU3Z691Kah5h/0o6Ow12PoS7I+3hNC5kT9hd40M6grIVl8af6zuO9PP7h3w49pbZfM4XTxKbLNzL1MtGiKZ5LN6bKxhXCUGqmDRcgjV/mkGKplM1m/57iYhqTjb4bpMFUwY38vEA5QDqn1wG6UYTRLbK4zxQtZreUK3R8hIdUF5TL7BAkC3RS78AX07HV5yOMqRaHS4B3zI1MerOMoQrUu9eEzu3nDI1r54ulp8Z467VofXSEQDuWGIrntWj4TLHza7a+zeax8apFqugdgstKuY2b6hFKzIZ3xO7l3XkokaxnVli9chl9CclKidMjQIDAQAB-----END PUBLIC KEY-----'
// int时间戳转4位byte数组，大端序
function timestampToBytes(timestamp) {
  let bytes = new Uint8Array(4)
  for (let i = 3; i >= 0; i--) {
    bytes[i] = (timestamp & 255)
    timestamp = timestamp >> 8
  }
  return bytes
}
const RandomString = e => {
  e = e || 32
  var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
    a = t.length,
    n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

const RandomBytes = () => {
  let random = RandomString(16)
  let bytes = new Uint8Array(random.length)
  for (let i = 0; i < random.length; i++) {
    bytes[i] = random.charCodeAt(i)
  }
  return bytes
}

const aesEncrypt = content => {
  let key = RSA.getPublicKey(publicKey)
  return RSA.encrypt(content, key)
}

export const enc = data => {
  let contentBytes = new Uint8Array(data.length)
  for (let i = 0; i < data.length; i++) {
    contentBytes[i] = data.charCodeAt(i)
  }
  let randomBytes = RandomBytes()
  let timestamp = Math.round(new Date().getTime() / 1000)

  let timeBytes = timestampToBytes(timestamp)
  // 加密原文
  let newDataBytes = new Uint8Array(data.length + 20)
  newDataBytes.set(randomBytes)
  newDataBytes.set(timeBytes, 16)
  newDataBytes.set(contentBytes, 20)
  return aesEncrypt(newDataBytes)
}

/**
 * RSA 公钥解密（核心！）
 */
function rsaPublicDecrypt(encryptedData) {
  const crypt = new JSEncrypt()
  crypt.setPublicKey(publicKey)
  console.log(encryptedData)
  // 关键：调用内部方法实现 公钥解密
  return crypt.key.decrypt(encryptedData, 'base64', 'utf8')
}

/**
 * 解密后拆包：去掉前 20 字节（16随机 + 4时间戳）
 */
function unpackData(decryptedStr) {
  const bytes = new Uint8Array(decryptedStr.length);
  for (let i = 0; i < decryptedStr.length; i++) {
    bytes[i] = decryptedStr.charCodeAt(i);
  }
  const realBytes = bytes.slice(20); // 跳过16随机+4时间戳
  return new TextDecoder().decode(realBytes);
}

/**
 * 最终对外解密方法
 * @param {string} encryptedData 加密后的字符串
 */
export function dec(encryptedData) {
  try {
    const decrypted = rsaPublicDecrypt(encryptedData, publicKey);
    console.log(decrypted)
    return unpackData(decrypted);
  } catch (e) {
    console.error('解密失败', e);
    return null;
  }
}
